import React from 'react';
import { CheckCircleFill, Headset, LightbulbFill } from "react-bootstrap-icons";
import "./schoolproduct.scss";

function Aboutdtls() {
  return (
    <div className="container mt-5">
      <div className="row align-items-center">

        {/* LEFT COLUMN – TEXT */}
        <div className="col-md-7">
          <h2 className="fw-bold text-primary">About Uiplus Technologies</h2>

          <p className="mt-3" style={{ textAlign: "justify" }}>
            <strong>Uiplus Technologies</strong> is a professional software development and IT solutions company 
            established in <strong>2025</strong>, committed to delivering scalable, secure, and high-performance digital solutions.
          </p>

          <p style={{ textAlign: "justify" }}>
            We specialize in custom software development, School ERP systems, web applications, 
            mobile app development, and enterprise solutions that help organizations streamline 
            operations and accelerate digital transformation.
          </p>

          <p style={{ textAlign: "justify" }}>
            Our team of experienced developers, designers, and technology consultants works 
            closely with clients to understand their business goals and deliver reliable, 
            user-friendly, and future-ready software solutions. We focus on innovation, 
            transparency, quality, and long-term client relationships.
          </p>

          <ul className="mt-3">
            <li>Custom Software & ERP Development</li>
            <li>School & College Management Systems</li>
            <li>Web & Mobile Application Development</li>
            <li>E-Commerce & CMS Solutions</li>
            <li>Cloud Integration & API Development</li>
            <li>Ongoing IT Support & Maintenance</li>
          </ul>
        </div>

        {/* RIGHT COLUMN – IMAGE */}
        <div className="col-md-5 text-center">
          <img
            src="/images/aboutdtls.jpg"
            alt="Uiplus Technologies Software Company"
            className="img-fluid rounded shadow"
            style={{ maxHeight: "380px" }}
          />
        </div>

      </div>

      {/* WHY CHOOSE US SECTION */}
      <div className="row mt-5">
        <div className="col-md-12 text-center">
          <h3 className="fw-bold mb-4">Why Choose Uiplus Technologies?</h3>

          <div className="row g-4">

            <div className="col-md-4">
              <div className="why-card p-4 shadow-sm h-100">
                <CheckCircleFill size={40} className="why-icon text-primary" />
                <h5 className="mt-3 fw-bold">Quality & Reliability</h5>
                <p>
                  We build clean, maintainable, and scalable software using 
                  modern technologies such as React, ASP.NET Core, and secure cloud platforms.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="why-card p-4 shadow-sm h-100">
                <Headset size={40} className="why-icon text-primary" />
                <h5 className="mt-3 fw-bold">Dedicated Support</h5>
                <p>
                  We provide transparent communication, timely delivery, 
                  and continuous technical support to ensure long-term business success.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="why-card p-4 shadow-sm h-100">
                <LightbulbFill size={40} className="why-icon text-primary" />
                <h5 className="mt-3 fw-bold">Innovation & Growth</h5>
                <p>
                  Our innovative approach helps businesses adapt to changing 
                  technologies and achieve sustainable digital growth.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
}

export default Aboutdtls;
